import React, { useEffect } from "react";
import { useBookingCustomerNumber_GetQuery } from "@graphql";
import locale from "@bonliva-crm/locale";
import { Body, Spinner } from "@components";

type Props = {
  areaOfExpertise: string;
  hospitalId: string;
  departmentIds: string[];
  onFetch?: (v: string) => void;
};

export function BookingCustomerNumber(props: Props) {
  const { areaOfExpertise, departmentIds, hospitalId } = props;

  const { data, error, loading } = useBookingCustomerNumber_GetQuery({
    variables: {
      areaOfExpertise,
      departmentIds,
      hospitalId
    },
    fetchPolicy: "network-only"
  });

  useEffect(() => {
    if (!loading) {
      props.onFetch?.(data?.customerNumberByAOE);
    }
  }, [data, loading]);

  if (error) {
    return null;
  }

  return (
    <Body style={{ display: "flex", alignItems: "center" }}>
      <span>{locale.CustomerNumberShort}:</span>

      {loading && <Spinner size={16} inline style={{ marginLeft: 8 }} />}

      {!loading && (
        <span style={{ marginLeft: 8 }}>
          {data.customerNumberByAOE || locale.NothingFound}
        </span>
      )}
    </Body>
  );
}
